export default __webpack_public_path__ + "static/media/loading_inv.33050358.svg";